/* assets/tb-lander.js — everything that moves on a lander.
   Gauge (sync + animate), add to cart, the race guard, Message to secure send,
   lander cart quantity changes, and the lander's own tracking.
   No dependencies. Loaded only by layout/lander.liquid. */
(function () {
  'use strict';
  if (window.__tbLander) return;
  window.__tbLander = true;

  var cfgEl = document.getElementById('tbl-cfg');
  var CFG = {};
  try { CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { CFG = {}; }
  var ROOT = String(CFG.root || '/').replace(/\/?$/, '/');
  var IN_FRAME = window.top !== window.self; // the Message-to-secure iframe loads this page too
  var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── helpers ────────────────────────────────────────────────────────────
  function money(cents) {
    var n = Math.max(0, Math.round(cents)) / 100;
    var fmt = CFG.money_format || '${{amount}}';
    var withDec = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount\s*\}\}/, withDec);
  }

  function post(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // Lander events only. Shopify already emits add-to-cart, checkout and purchase.
  // Shopify.analytics.publish reaches web pixels (sandboxed — they can't read
  // window.dataLayer). dataLayer is kept as a belt for anything on-page.
  function track(name, data) {
    if (IN_FRAME) return;
    data = data || {};
    data.tb_page = CFG.handle || '';
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    window.dataLayer = window.dataLayer || [];
    var ev = { event: name };
    for (var k in data) ev[k] = data[k];
    window.dataLayer.push(ev);
  }

  // ── scroll lock ────────────────────────────────────────────────────────
  // overflow:hidden on <html> is what iPhone browsers ignore and what breaks the
  // pinned tab bar afterwards. Freeze the body in place instead, then put the
  // page back exactly where it was.
  var lockY = 0, locked = false;
  function lock() {
    if (locked) return;
    locked = true;
    lockY = window.scrollY || window.pageYOffset || 0;
    var b = document.body.style;
    b.position = 'fixed'; b.top = (-lockY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
    document.documentElement.classList.add('tbl-lock');
  }
  function unlock() {
    if (!locked) return;
    locked = false;
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    document.documentElement.classList.remove('tbl-lock');
    window.scrollTo(0, lockY);
  }

  // ── gauge ──────────────────────────────────────────────────────────────
  var G = document.querySelector('[data-tbl-gauge]');
  // Last in <body>, with the sheets after it, so the lander's own layers win
  // over anything Shopify pins to the same corner (the hCaptcha badge).
  if (G && !IN_FRAME) {
    document.body.appendChild(G);
    document.querySelectorAll('[data-tbl-sheet], [data-tbl-zoombox]').forEach(function (el) { document.body.appendChild(el); });
  }
  var gate = G ? parseInt(G.getAttribute('data-gate'), 10) || 0 : 0;
  var wasDone = G ? G.getAttribute('data-done') === 'true' : false;
  var shownShort = null;
  var rollRaf = 0, pillTimer = 0;

  function q(sel) { return G ? G.querySelector(sel) : null; }

  function roll(target) {
    var el = q('[data-tbl-short]');
    if (!el) return;
    if (shownShort === null || REDUCE) { shownShort = target; el.textContent = money(target); return; }
    var from = shownShort, start = 0, dur = 650;
    cancelAnimationFrame(rollRaf);
    function tick(now) {
      if (!start) start = now;
      var k = Math.min(1, (now - start) / dur);
      var e = 1 - Math.pow(1 - k, 3);
      shownShort = from + (target - from) * e;
      el.textContent = money(shownShort);
      if (k < 1) rollRaf = requestAnimationFrame(tick);
    }
    rollRaf = requestAnimationFrame(tick);
  }

  function pop(amount) {
    var el = q('[data-tbl-pop]');
    if (!el || !amount) return;
    el.textContent = '+' + money(amount);
    el.classList.remove('is-on');
    void el.offsetWidth; // restart the animation
    el.classList.add('is-on');
  }

  function render(total, count, popAmount) {
    if (!G || !gate) return;
    var short = Math.max(0, gate - total);
    var done = total >= gate;
    var fill = q('[data-tbl-fill]');
    var track = fill ? fill.parentNode : null;
    var progress = q('[data-tbl-progress]');
    var pill = q('[data-tbl-pill]');
    var btn = q('[data-tbl-cartbtn]');
    var cnt = q('[data-tbl-count]');

    if (cnt) cnt.textContent = count;
    if (btn) btn.hidden = count === 0;

    clearTimeout(pillTimer);
    if (!done) {
      if (progress) progress.hidden = false;
      if (pill) pill.hidden = true;
      if (track) track.classList.remove('is-flash');
    }
    roll(short);
    if (fill) fill.style.transform = 'scaleX(' + Math.min(1, total / gate) + ')';
    pop(popAmount);

    if (done && !wasDone) {
      // Crossing the line: fill lands, flashes once, collapses into the pill.
      if (progress) progress.hidden = false;
      if (track) { track.classList.remove('is-flash'); void track.offsetWidth; track.classList.add('is-flash'); }
      pillTimer = setTimeout(function () {
        if (progress) progress.hidden = true;
        if (pill) pill.hidden = false;
      }, REDUCE ? 0 : 900);
    } else if (done) {
      if (progress) progress.hidden = true;
      if (pill) pill.hidden = false;
    }
    wasDone = done;
  }

  function sync(popAmount) {
    return getCart().then(function (c) { render(c.total_price, c.item_count, popAmount); return c; });
  }

  // First paint is server-rendered; this catches anything newer (another tab,
  // back/forward cache) and sets the odometer's starting point.
  if (G && !IN_FRAME) sync(0).catch(function () {});
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(0).catch(function () {}); });

  // ── add to cart ────────────────────────────────────────────────────────
  function flipToSecure(btn) {
    var card = btn.closest('[data-tbl-card]');
    var sec = card && card.querySelector('[data-tbl-secure]');
    if (!sec) return;
    btn.hidden = true;
    sec.hidden = false;
  }

  function setLabel(btn, text, ms) {
    var orig = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', orig);
    btn.textContent = text;
    setTimeout(function () { btn.textContent = orig; }, ms);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tbl-add]');
    if (!btn || btn.hasAttribute('aria-busy')) return;

    var ids = (btn.getAttribute('data-ids') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    var price = parseInt(btn.getAttribute('data-price'), 10) || 0;
    btn.setAttribute('aria-busy', 'true');

    var gone = false;
    post('cart/add.js', { items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
      .then(function (r) {
        // 422 = a part sold out since this page rendered. Say so the calm way.
        if (r.status === 422) { gone = true; throw new Error('unavailable'); }
        if (!r.ok) throw new Error('add ' + r.status);
        return r.json();
      })
      .then(function () {
        // Stamp the cart with this lander: the cart's back link reads it,
        // and it rides through to the order as the conversion record.
        if (!CFG.handle || CFG.attr === CFG.handle) return;
        return post('cart/update.js', { attributes: { lander: CFG.handle } })
          .then(function () { CFG.attr = CFG.handle; });
      })
      .then(function () { return sync(price); })
      .then(function () {
        setLabel(btn, 'Added', 1200);
        track('tb_lander_add', { tb_section: CFG.aisle || '', tb_kit: btn.getAttribute('data-kit') || '' });
      })
      .catch(function (err) {
        if (gone) { flipToSecure(btn); sync(0).catch(function () {}); return; }
        setLabel(btn, 'Try again', 1600);
        if (window.console) console.error('[TB lander] add', err);
      })
      .then(function () { btn.removeAttribute('aria-busy'); });
  });

  // ── sheets: one slide-in, three uses (details / Message to secure / cart) ──
  // Same panel everywhere: full screen on mobile, right-hand panel on desktop.
  var current = null, lastFocus = null, closeTimer = 0;
  function sheet(name) { return document.querySelector('[data-tbl-sheet="' + name + '"]'); }

  function openSheet(el, from) {
    if (!el) return;
    if (current && current !== el) closeSheet(true);
    clearTimeout(closeTimer);
    if (!current) lastFocus = from || lastFocus; // panel-to-panel keeps the original
    current = el;
    el.hidden = false;
    lock();
    var panel = el.querySelector('.tbl-sheet__panel');
    if (panel) panel.scrollTop = 0;
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      var back = el.querySelector('[data-tbl-close].tbl-sheet__x');
      if (back) setTimeout(function () { back.focus({ preventScroll: true }); }, REDUCE ? 0 : 320);
    });
  }

  function closeSheet(instant) {
    var el = current;
    if (!el) return;
    current = null;
    el.classList.remove('is-open');
    unlock();
    if (instant || REDUCE) { el.hidden = true; }
    else closeTimer = setTimeout(function () { el.hidden = true; }, 300);
    if (!instant && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  // ── links inside panel text ──────────────────────────────────────────────
  // Policies and descriptions come from Shopify with their own links. Nothing
  // may leave the lander: a link to one of the policies opens that policy in
  // the panel; email/phone links stay; everything else becomes plain text.
  var POLICY = { 'shipping-policy': 'shipping', 'refund-policy': 'refund', 'privacy-policy': 'privacy', 'terms-of-service': 'terms' };
  function cleanLinks(root) {
    root.querySelectorAll('a[href]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (/^(mailto|tel):/i.test(href)) return;
      var m = href.match(/\/policies\/(shipping-policy|refund-policy|privacy-policy|terms-of-service)/i);
      var key = m && POLICY[m[1].toLowerCase()];
      if (key && document.querySelector('template[data-tbl-info-body="' + key + '"]')) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tbl-inlink';
        b.setAttribute('data-tbl-info', key);
        b.textContent = a.textContent;
        a.replaceWith(b);
        return;
      }
      var span = document.createElement('span');
      span.textContent = a.textContent;
      a.replaceWith(span);
    });
  }

  // ── details panel ────────────────────────────────────────────────────────
  var D = sheet('details');
  var dCard = null;

  function dCtaSync() {
    if (!D || !dCard) return;
    var cta = D.querySelector('[data-tbl-d-cta]');
    var add = dCard.querySelector('[data-tbl-add]');
    var addLive = add && !add.hidden;
    cta.textContent = addLive ? 'Add to cart' : 'Message to secure';
    cta.className = 'tb-btn tb-btn--block ' + (addLive ? 'tb-btn--add' : 'tb-btn--secure');
  }

  function openDetails(card, from) {
    if (!D || !card) return;
    dCard = card;
    function txt(sel) { var e = card.querySelector(sel); return e ? e.textContent.trim() : ''; }
    D.querySelector('[data-tbl-d-brand]').textContent = txt('.tb-card__brand');
    D.querySelector('[data-tbl-d-title]').textContent = txt('.tb-card__title');
    var fits = card.querySelector('.tb-card__fits');
    var dFits = D.querySelector('[data-tbl-d-fits]');
    dFits.innerHTML = fits ? fits.innerHTML : '';
    dFits.hidden = !fits;
    D.querySelector('[data-tbl-d-price]').textContent = txt('.tb-card__price');
    var tpl = document.querySelector('template[data-tbl-desc="' + card.getAttribute('data-product') + '"]');
    var body = D.querySelector('[data-tbl-d-body]');
    body.innerHTML = '';
    if (tpl) { body.appendChild(tpl.content.cloneNode(true)); cleanLinks(body); }
    dCtaSync();
    openSheet(D, from);
    track('tb_lander_details', { tb_section: CFG.aisle || '', tb_kit: txt('.tb-card__title') });
  }

  // ── Message to secure ────────────────────────────────────────────────────
  var S = sheet('secure');

  // mode: 'secure' (default) or 'help' — same panel, same send, different words.
  function openSecure(item, from, mode) {
    if (!S) return;
    mode = mode === 'help' ? 'help' : 'secure';
    S.setAttribute('data-mode', mode);
    var box = S.querySelector('[data-tbl-msg]');
    var tog = S.querySelector('[data-tbl-msg-toggle]');
    var ta = S.querySelector('textarea');
    if (mode === 'help') {
      if (box) box.hidden = false;
      if (ta) ta.required = true;
      if (ta) ta.placeholder = 'What would you like to know?';
    } else {
      if (box) box.hidden = true;
      if (tog) tog.hidden = false;
      if (ta) { ta.required = false; ta.placeholder = 'Anything else we should know?'; }
    }
    var f = S.querySelector('[data-tbl-f-item]');
    var pg = S.querySelector('[data-tbl-f-page]');
    if (f) f.value = item || '';
    if (pg) pg.value = window.location.href;
    S.querySelectorAll('[data-tbl-ctx]').forEach(function (el) { el.textContent = item || ''; });
    var form = S.querySelector('[data-tbl-ask-form]');
    var ok = S.querySelector('[data-tbl-ask-ok]');
    var err = S.querySelector('[data-tbl-ask-err]');
    if (form) form.hidden = false;
    if (ok) ok.hidden = true;
    if (err) err.hidden = true;
    openSheet(S, from);
    var email = S.querySelector('input[type="email"]');
    if (email) setTimeout(function () { email.focus({ preventScroll: true }); }, REDUCE ? 0 : 340);
    if (mode === 'help') track('tb_lander_help_open', { tb_section: CFG.aisle || '' });
    else track('tb_lander_secure_open', { tb_section: CFG.aisle || '', tb_kit: item || '' });
  }

  // ── info panel: FAQ + policies, read live from the page's templates ──────
  var I = sheet('info');
  function openInfo(key, from) {
    var tpl = document.querySelector('template[data-tbl-info-body="' + key + '"]');
    if (!I || !tpl) return;
    I.querySelector('[data-tbl-i-title]').textContent = tpl.getAttribute('data-title') || '';
    var body = I.querySelector('[data-tbl-i-body]');
    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));
    cleanLinks(body);
    var ip = I.querySelector('.tbl-sheet__panel');
    if (ip) ip.scrollTop = 0;
    openSheet(I, from);
    track('tb_lander_info', { tb_info: key });
  }

  // ── cart (slide-in on landers; the /cart?view=lander page is the fallback) ──
  var C = sheet('cart');

  function swapCartBody(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-tbl-cart-body]');
    if (!fresh) return;
    document.querySelectorAll('[data-tbl-cart-body]').forEach(function (cur) {
      if (cur.getAttribute('data-section') === fresh.getAttribute('data-section')) cur.innerHTML = fresh.innerHTML;
    });
  }

  function refreshDrawer() {
    return fetch(ROOT + '?sections=tb-lander-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { swapCartBody(j['tb-lander-drawer']); });
  }

  function openCart(from) {
    if (!C) return false;
    openSheet(C, from);
    refreshDrawer().catch(function () {});
    track('tb_lander_cart_open', { tb_section: CFG.aisle || '' });
    return true;
  }

  function cartBusy(body, on) {
    if (on) body.setAttribute('aria-busy', 'true'); else body.removeAttribute('aria-busy');
  }
  function cartErr(body, err) {
    var m = body.querySelector('[data-tbl-cart-err]');
    if (m) m.hidden = false;
    if (window.console) console.error('[TB lander] cart', err);
  }

  // ── one click router ─────────────────────────────────────────────────────
  var zoomBox = document.querySelector('[data-tbl-zoombox]');
  var zoomLast = null;
  function closeZoom() {
    if (!zoomBox || zoomBox.hidden) return;
    zoomBox.classList.remove('is-open');
    zoomBox.hidden = true;
    unlock();
    if (zoomLast && zoomLast.focus) zoomLast.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var z = t.closest('[data-tbl-zoom]');
    if (z && zoomBox) {
      var fr = z.closest('.tb-card__media');
      fr = fr && fr.querySelector('.tb-card__frame');
      var tile = fr ? getComputedStyle(fr).getPropertyValue('--tb-tile-bg').trim() : '';
      zoomBox.querySelector('[data-tbl-zoomtile]').style.background = tile || '#ffffff';
      var zi = zoomBox.querySelector('[data-tbl-zoomimg]');
      zi.src = z.getAttribute('data-src');
      zi.classList.toggle('is-flipped', z.hasAttribute('data-flip'));
      zoomLast = z;
      zoomBox.hidden = false;
      lock();
      requestAnimationFrame(function () {
        zoomBox.classList.add('is-open');
        var x = zoomBox.querySelector('.tbl-zoom__x');
        if (x) x.focus({ preventScroll: true });
      });
      return;
    }
    if (zoomBox && !zoomBox.hidden && t.closest('[data-tbl-zoomclose]')) { closeZoom(); return; }

    var det = t.closest('[data-tbl-details]');
    if (det) { openDetails(det.closest('[data-tbl-card]'), det); return; }

    var cta = t.closest('[data-tbl-d-cta]');
    if (cta && dCard) {
      var add = dCard.querySelector('[data-tbl-add]');
      var sec = dCard.querySelector('[data-tbl-secure]');
      if (add && !add.hidden) {
        add.click();
        cta.textContent = 'Added';
        setTimeout(dCtaSync, 1300);
      } else if (sec) {
        openSecure(sec.getAttribute('data-item'), sec);
      }
      return;
    }

    var info = t.closest('[data-tbl-info]');
    if (info) { openInfo(info.getAttribute('data-tbl-info'), info); return; }

    var help = t.closest('[data-tbl-help]');
    if (help) { openSecure('Question before ordering — ' + (CFG.bike || '') + ' lander', help, 'help'); return; }

    var secBtn = t.closest('[data-tbl-secure]');
    if (secBtn) { openSecure(secBtn.getAttribute('data-item'), secBtn); return; }

    var cb = t.closest('[data-tbl-cartbtn]');
    if (cb && C) { e.preventDefault(); openCart(cb); return; }

    if (t.closest('[data-tbl-close]')) { closeSheet(); return; }

    var tog = t.closest('[data-tbl-msg-toggle]');
    if (tog && S) {
      var box = S.querySelector('[data-tbl-msg]');
      if (box) { box.hidden = false; tog.hidden = true; var ta = box.querySelector('textarea'); if (ta) ta.focus(); }
      return;
    }

    // quantity / remove
    var qb = t.closest('[data-tbl-qty]');
    if (qb) {
      var body = qb.closest('[data-tbl-cart-body]');
      if (!body || body.hasAttribute('aria-busy')) return;
      var name = body.getAttribute('data-section');
      cartBusy(body, true);
      post('cart/change.js', {
        line: parseInt(qb.getAttribute('data-line'), 10),
        quantity: Math.max(0, parseInt(qb.getAttribute('data-q'), 10) || 0),
        sections: name,
        sections_url: window.location.pathname + window.location.search
      })
        .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); })
        .then(function (c) {
          swapCartBody(c.sections && c.sections[name]);
          render(c.total_price, c.item_count, 0);
        })
        .catch(function (err) { cartErr(body, err); })
        .then(function () { cartBusy(body, false); });
      return;
    }

    // remove all
    var clr = t.closest('[data-tbl-clear]');
    if (clr) {
      var cbody = clr.closest('[data-tbl-cart-body]');
      if (!cbody || cbody.hasAttribute('aria-busy')) return;
      var cname = cbody.getAttribute('data-section');
      cartBusy(cbody, true);
      post('cart/clear.js', {})
        .then(function (r) { if (!r.ok) throw new Error('clear ' + r.status); })
        .then(function () {
          return fetch(ROOT + '?sections=' + encodeURIComponent(cname), { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (j) { swapCartBody(j[cname]); });
        })
        .then(function () { render(0, 0, 0); track('tb_lander_cart_clear', {}); })
        .catch(function (err) { cartErr(cbody, err); })
        .then(function () { cartBusy(cbody, false); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (zoomBox && !zoomBox.hidden) { closeZoom(); return; }
    closeSheet();
  });

  // The send. Same mechanism as tb-finder.js: Shopify submits its own form with
  // its own token, aimed at a hidden frame. NO preventDefault — that's the point.
  var FRAME = 'tbl-secure-sink';
  function sink() {
    var f = document.getElementById(FRAME);
    if (f) return f;
    f = document.createElement('iframe');
    f.id = FRAME;
    f.name = FRAME;
    f.setAttribute('aria-hidden', 'true');
    f.setAttribute('tabindex', '-1');
    f.style.cssText = 'position:absolute;width:0;height:0;border:0;left:-9999px;';
    document.body.appendChild(f);
    return f;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!S || !form || !S.contains(form)) return;
    var wrap = S.querySelector('[data-tbl-ask-form]');
    var ok = S.querySelector('[data-tbl-ask-ok]');
    var err = S.querySelector('[data-tbl-ask-err]');
    var submits = S.querySelectorAll('[data-tbl-ask-submit]');
    function lockSubmits(on) { submits.forEach(function (b) { b.disabled = on; }); }

    if (form.hasAttribute('data-sending')) { e.preventDefault(); return; }
    form.setAttribute('data-sending', '');
    if (err) err.hidden = true;

    var frame = sink();
    form.target = FRAME;
    var done = false;

    function settle(sent, why) {
      if (done) return;
      done = true;
      clearTimeout(timer);
      frame.onload = null;
      form.removeAttribute('data-sending');
      form.removeAttribute('target');
      lockSubmits(false);
      if (sent) {
        if (wrap) wrap.hidden = true;
        if (ok) ok.hidden = false;
        form.reset();
        track(S.getAttribute('data-mode') === 'help' ? 'tb_lander_help_sent' : 'tb_lander_secure_sent', { tb_section: CFG.aisle || '' });
      } else {
        if (err) err.hidden = false;
        if (window.console) console.error('[TB lander] secure', why);
      }
    }

    frame.onload = function () {
      var landed = '';
      try { landed = frame.contentWindow.location.href; } catch (e2) { return settle(true, null); }
      if (!landed || landed === 'about:blank') return;
      settle(landed.indexOf('contact_posted=true') > -1 || landed.indexOf('/challenge') === -1,
             'landed on ' + landed);
    };

    var timer = setTimeout(function () { settle(false, 'timed out'); }, 12000);
    setTimeout(function () { lockSubmits(true); }, 0);
  }, true);

  // ── hCaptcha badge: keep it hidden ─────────────────────────────────────
  // Shopify's badge is #shop-hcaptcha-badge-container. The CSS hides it, but
  // Shopify redraws it when a contact form wakes up (opening Message to secure
  // or Help). Re-hide it inline, with top priority, every time it appears or is
  // restyled. Only that one element — the challenge is never touched.
  (function () {
    var ID = 'shop-hcaptcha-badge-container';
    function hide() {
      var el = document.getElementById(ID);
      if (!el) return;
      if (el.style.getPropertyValue('display') === 'none' && el.style.getPropertyPriority('display') === 'important') return;
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
    }
    hide();
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; hide(); });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'id'] });
  })();

  // ── product links: ?p=<handle>[&v=<variant id>] ─────────────────────────
  // Lands on that product's card: if it lives in another aisle, load that aisle
  // (same p/v), then scroll the card into view and highlight it briefly.
  (function () {
    if (IN_FRAME || !window.URLSearchParams) return;
    var q = new URLSearchParams(window.location.search);
    var h = q.get('p');
    if (!h) return;
    var v = q.get('v');
    var sel = '[data-tbl-card][data-handle="' + h.replace(/"/g, '') + '"]';
    var card = (v && document.querySelector(sel + '[data-variant="' + v.replace(/"/g, '') + '"]')) || document.querySelector(sel);
    if (!card) {
      var where = {};
      try { where = JSON.parse((document.getElementById('tbl-where') || {}).textContent || '{}'); } catch (e) {}
      if (!(h in where)) return;
      var want = where[h];
      var now = q.get('view') || '';
      if (want === now) return; // already the right aisle; product just isn't a card here
      if (want) q.set('view', want); else q.delete('view');
      window.location.replace(window.location.pathname + '?' + q.toString() + window.location.hash);
      return;
    }
    function land() {
      card.scrollIntoView({ block: 'center', behavior: REDUCE ? 'auto' : 'smooth' });
      card.classList.add('is-linked');
      setTimeout(function () { card.classList.remove('is-linked'); }, 2600);
      track('tb_lander_link', { tb_section: CFG.aisle || '', tb_kit: h });
    }
    if (document.readyState === 'complete') setTimeout(land, 60);
    else window.addEventListener('load', function () { setTimeout(land, 60); });
  })();

  // ── view ───────────────────────────────────────────────────────────────
  if (document.querySelector('[data-tbl-page]')) {
    track('tb_lander_view', { tb_section: CFG.aisle || '' });
  }
})();
